import React from 'react';
import {Button, Modal} from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import WorkdocStore from 'stores/WorkdocStore';
import ICheck from 'component/element/ICheck';
import Form from "react-jsonschema-form";
var NotificationSystem = require('react-notification-system');

const schema = {
    title: "",
    type: "object",
    required: [],
    properties: {
        program_visible: {type: "boolean", title: "แสดงโปรแกรม", default: false},
        check_visible: {type: "boolean", title: "check_visible", default: false},
        wage_quantity_visible: {type: "boolean", title: "แสดงจำนวนในตารางค่าแรง", default: false},
        part_cost_per_unit_visible: {type: "boolean", title: "แสดงราคาต้นทุนในตารางค่าอะไหล่", default: false},
        part_first: {type: "boolean", title: "แสดงตารางค่าอะไหล่อยู่ด้านบน", default: false},
        discount_visible: {type: "boolean", title: "แสดงส่วนลด", default: false},
        discount_sum_visible: {type: "boolean", title: "แสดงส่วนลดรวม", default: false},
        part_cost_require: {type: "boolean", title: "บังคับใส่ต้นทุนอะไหล่", default: false},
        init_no_of_wage: {type: "string", title: "จำนวนรายการค่าแรง", default: "10"},
        init_no_of_part: {type: "string", title: "จำนวนรายการค่าอะไหล่", default: "10"},
        cost_type: {type: "string",enum:["from_stock","fifo","average"],"enumNames":["ราคาในสต็อก","FIFO","ค่าเฉลี่ยการซื้อ"], title: "วิธีคิดต้นทุน", default: "from_stock"},        
    }    
}
const uiSchema = {
    program_visible: {'ui:field': ICheck},
    check_visible: {'ui:field': ICheck},
    wage_quantity_visible: {'ui:field': ICheck},
    part_cost_per_unit_visible: {'ui:field': ICheck},
    part_first: {'ui:field': ICheck},
    discount_visible: {'ui:field': ICheck},
    discount_sum_visible: {'ui:field': ICheck},
    part_cost_require: {'ui:field': ICheck},
    cost_type:{"ui:widget": "radio"}
}
const _formData = {
    program_visible: false,
    check_visible: false,
    wage_quantity_visible: false,
    part_cost_per_unit_visible: false,
    part_first: false,
    discount_visible: false,
    discount_sum_visible: false,
    init_no_of_wage: '',
    init_no_of_part: '',
    part_cost_require: false,
    cost_type:"from_stock"
}

class ConfigFixingListModal extends React.Component {

  constructor(...args) {
    super(...args)
    this.state = {
        formData:_formData
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    if (this.props.mode!=='modal') {
        this.loadData()
    }
  }

  loadData() {
    WorkdocStore.loadConfigFixingList((result)=>{
        this.setState({formData:result.data})
    })
  }

  onChange(e) {
    this.setState({formData:e.formData})
  }

  onSaveClick() {
      let {formData} = this.state
      WorkdocStore.saveConfigFixingList(formData,(result)=>{
        if (result.status==='OK') {
            this._notificationSystem.addNotification({
                title: 'แจ้งเตือน',
                message: 'บันทึกรายการสำเร็จ',
                level: 'info',
                position: 'tc'
            });
        }
    },()=>{
        this._notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'บันทึกรายการไม่สำเร็จ',
            level: 'error',
            position: 'tc'
        });
    })
  }

  renderForm() {
      let {formData} = this.state
      return(
        <div>  
            <Form 
                schema={schema}
                uiSchema={uiSchema}
                formData={formData}
                onChange={this.onChange.bind(this)}
            >
                <br/>
            </Form>
            <div style={{textAlign:'right'}}>
                <Button className="btn-primary" onClick={this.onSaveClick.bind(this)}>
                    <FontAwesome name='save' />&nbsp;บันทึก
                </Button>
            </div>   
            <NotificationSystem ref="notificationSystem" /> 
        </div>    
      )
  }

  render() {
    let {show,mode} = this.props
    let {formData} = this.state
    if (mode!=='modal') {
        return this.renderForm()
    }
    return (
        <div>
            <Modal show={show} onShow={this.loadData.bind(this)} onHide={this.props.onHide}>
                <Modal.Header closeButton>
                <Modal.Title>
                    ตั้งค่า
                </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Form 
                    schema={schema}
                    uiSchema={uiSchema}
                    formData={formData}
                    onChange={this.onChange.bind(this)}
                >
                <br/>
                </Form>
                </Modal.Body>
                <Modal.Footer>
                <Button className="btn-primary" onClick={this.onSaveClick.bind(this)}>
                    <FontAwesome name='save' />&nbsp;บันทึก
                </Button>
                <Button className="btn-default" onClick={this.props.onHide}>
                    <FontAwesome name='close' />&nbsp;ปิด
                </Button>            
                </Modal.Footer>  
            </Modal>
            <NotificationSystem ref="notificationSystem" />
        </div>    
    )
  }
}

ConfigFixingListModal.defaultProps = {
    mode: 'modal'
}

export default ConfigFixingListModal;



// WEBPACK FOOTER //
// ./src/component/element/ConfigFixingListModal.js